// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"d52e4408","80":"ca6eec32","204":"371d760e","241":"e54c2d8b","444":"93291813","519":"1edf5f21","530":"876783fa","557":"98b1e39b","681":"44bd3371","736":"95390296","882":"2b7865f0"}[chunkId] + ".chunk.js";
};